import React from "react"
import logo from '../images/LamarLogo.png';
import { faFacebookF, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import {faBars} from '@fortawesome/free-solid-svg-icons'
import {fadeIn} from 'react-animations';
import styled, {keyframes} from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Drawer from '@material-ui/core/Drawer';
import Grid from '@material-ui/core/Grid';
import { Link } from "gatsby";
import colors from '../styles/colors';
import {device} from '../styles/media';


const fadingAnimation = keyframes`${fadeIn}`;

const HiddenLink = styled(Link)`
    padding: 1.2rem 12rem 1.2rem 2rem;
    text-decoration: none;
    color: white;
    border-top: 1px solid white;
    cursor: pointer;
    transition: 0.25s;

    :hover{
        color: ${colors.secondary};
    }
`
const StyledHidden = styled.div`
    padding: 1.2rem 12rem 1.2rem 0;
    border-top: 1px solid white;
    transition: 0.25s;
`
const HiddenSocialLink = styled.a`
    padding-left: 1rem;
    color: white;
    text-decoration: none;
    cursor: pointer;

    :hover{
        color: ${colors.secondary};
    }
`
const StyledLink = styled(Link)`
    color: white;
    padding: 1.0rem 2.0rem;
    float: left;
    text-decoration: none;
    line-height: 2.5rem;
    font-weight: 400;
    font-size: 1.1rem;
    transition: 0.25s; 

    :hover{
        color: ${colors.secondary};
    }

    @media ${device.tablet}{
        display: none;
        padding-left: 1rem;
    }
`
const SocialLink = styled.a`
    color: white;
    padding: 1.0rem;
    float: left;
    text-decoration: none;
    line-height: 2.5rem;
    font-weight: 400;
    font-size: 1.1rem;
    transition: 0.25s;  

    :hover{
        color: ${colors.secondary};
    }

    @media ${device.tablet}{
        display: none;
        padding-left: 1rem;
    }
`

const StyledBrandLink = styled(StyledLink)`
    padding: 1.0rem 4.0rem;
    font-size: 2.0rem;
    display: inline-flex !important;
    vertical-align: middle;
`
const StyledDrawer = styled(Drawer)`
    & > .MuiPaper-root {
        background-color: ${colors.primaryLight};
    }
`
const StyledHiddenIcon = styled(FontAwesomeIcon)`
    color: white;
    padding: 1.0rem 1.5rem !important;
    float: left;
    text-decoration: none;
    line-height: 2.5rem;
    font-weight: 400;
    display: none;
    font-size: 35px;
    cursor: pointer;
    transition: 0.25s;

    :hover{
        color: ${colors.secondary};
    }
    @media ${device.tablet}{
        display: initial;
        padding: .1rem 1.2rem 0 0;
    }
`
const StyledImg = styled.img`
    max-width: 2rem;
    max-height: 75px;
`
const StyledNavBar = styled(Grid)`
    z-index: 1;
    background-color: ${colors.primaryLight};
    height: 75px;
    width: 100vw;
    border-bottom: 1px solid rgba(250, 275, 270, 0.1);
    position: fixed;
    right: 0;
    animation: 2s ${fadingAnimation};
`
const StyledIcons = styled.div`
    position: fixed;
    right: 0;
    padding-right: 10rem;
`



const Header = () => {
    const [state, setState] = React.useState({
        open: false
    })

    const toggleDrawer = () => {
        setState({
            open: !state.open
        })
    }
    return (
        <Grid container>
            <Grid item xl={1}></Grid>
            <StyledNavBar item xl={11} lg={12}>
                <StyledDrawer open={state.open} onClick={toggleDrawer}>    
                    <HiddenLink to='/'>Home</HiddenLink>
                    <HiddenLink to='/about'>About Us</HiddenLink>
                    <HiddenLink to='/contact'>Contact Us</HiddenLink>
                    <StyledHidden>
                        <HiddenSocialLink target='_blank' href='https://www.facebook.com/taylorlamarconsulting' social aria-label='Go to Facebook Page'><FontAwesomeIcon icon={faFacebookF} aria-hidden="true"/></HiddenSocialLink>
                        <HiddenSocialLink target='_blank' href='https://www.instagram.com/taylor.lamar.consulting/' social aria-label='Go to Instagram Page'><FontAwesomeIcon icon={faInstagram} aria-hidden="true"/></HiddenSocialLink>
                        <HiddenSocialLink target='_blank' href='https://www.linkedin.com/company/taylor-lamar-consulting/' social aria-label='Go to LinkedIn Page'><FontAwesomeIcon icon={faLinkedinIn} aria-hidden="true"/></HiddenSocialLink>
                    </StyledHidden>
                </StyledDrawer>
                <StyledHiddenIcon onClick={toggleDrawer} icon={faBars}/>
                <StyledBrandLink to='/'><StyledImg src={logo} alt='LaMar Software Logo'/></StyledBrandLink>
                <StyledLink to='/about'>About</StyledLink>
                <StyledLink to='/contact'>Contact</StyledLink>
                <StyledIcons>
                    <SocialLink target='_blank' href='https://www.facebook.com/taylorlamarconsulting' social aria-label='Go to Facebook Page'><FontAwesomeIcon icon={faFacebookF} aria-hidden="true"/></SocialLink>
                    <SocialLink target='_blank' href='https://www.instagram.com/taylor.lamar.consulting/' social aria-label='Go to Instagram Page'><FontAwesomeIcon icon={faInstagram} aria-hidden="true"/></SocialLink>
                    <SocialLink target='_blank' href='https://www.linkedin.com/company/taylor-lamar-consulting/' social aria-label='Go to LinkedIn Page'><FontAwesomeIcon icon={faLinkedinIn} aria-hidden="true"/></SocialLink>  
                </StyledIcons>
            </StyledNavBar>
        </Grid>
    )
}


export default Header
